<template>
    <div style="height: 100%">
        <v-card style="height: 100%">
            <v-toolbar
                flat
                height="70"
            >
                <v-spacer></v-spacer>

                <v-btn icon color="accent" v-if="!schedule.active" @click="setActive(true)">
                    <v-icon >mdi-alarm-check</v-icon>
                </v-btn>
                <v-btn icon color="primary" v-else @click="setActive(false)">
                    <v-icon >mdi-alarm-off</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="text-center pb-14">
                <v-progress-circular
                    :rotate="90"
                    :size="200"
                    :value="100"
                    :width="10"
                    color="accent"
                >
                    <p class="ma-0 text-h5 primary--text">{{ hour.toLocaleTimeString() }}</p>
                </v-progress-circular>
                <v-list class="text-left mt-6">
                    <v-list-item>
                        <v-list-item-content class="font-weight-bold">
                            Nombre
                        </v-list-item-content>
                        <v-list-item-action>
                            {{ schedule.name }}
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content class="font-weight-bold">
                            Accion:
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-chip v-if="schedule.value" label color="accent">Encender</v-chip>
                            <v-chip v-else label color="primary">Apagar</v-chip>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content class="font-weight-bold">
                            Estatus:
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-chip v-if="schedule.active" label color="accent">Activo</v-chip>
                            <v-chip v-else label color="primary">Inactivo</v-chip>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
            </v-card-text>
            <v-card-actions class="action-btn">
                <v-btn outlined color="error" block @click="clickDelete">Eliminar</v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name:'info',
    props: ['schedule'],
    computed:{
        hour(){
            let time_int = this.schedule.time.split(':')
            let hour = new Date()
            hour.setUTCHours(parseInt(time_int[0]),parseInt(time_int[1]),0,0)
            return hour
        }
    },
    methods: {
        ...mapActions({ 
            updateData: 'schedules/updateScheduleData',
            deleteSchedule: 'schedules/deleteSchedule'
        }),
        async setActive(active){
            try {
                await this.updateData({
                    schedule: this.schedule.id,
                    props: { active: active }
                })
            } catch (error) {
                console.log(error)
            }
        },
        async clickDelete(){
            try {
                await this.deleteSchedule(this.schedule.id)
                this.$router.push({ name: 'Home' })
            } catch (error) {
                console.log(error)
            }
        }
    }
}
</script>

<style scoped>
    .action-btn{
        position: absolute;
        bottom: 10px;
        left: 10px;
        right: 10px;
    }
    .active-label{
        height: 100%;
        border-top-right-radius: 0px !important;
        border-bottom-right-radius: 0px !important;
    }
</style>